import { useSearchParams } from "react-router-dom";
import { Container, DialogContent } from "@mui/material";
import { t } from "i18next";

//import constants
import { BREAKPOINT, WIDTH } from "../../../constants/breakpoints";

//import general components
import BaseDialog from "../../common/base-dialog/base-dialog";
import DetailsHeader from "../../common/details-header/details-header";

//import view components
import SearchFormContent from "./search-form-content";

function BusSearchForm({ setRequestFlag, openSearchForm, setUid }) {
    //general variables
    const [searchParams, setSearchParams] = useSearchParams();

    //sessionStorage variables
    const { isItinerary } = JSON.parse(sessionStorage.getItem("generalInformation")) || {};
    const busInformation = JSON.parse(sessionStorage.getItem("busInformation"));    

    //handle close modal
    const handleClose = () => {
        if (isItinerary || searchParams.get("action") === "edit") {
            searchParams.delete("action");
            setSearchParams(searchParams);
        }
    };

    return (
        <>
            {WIDTH > BREAKPOINT ? (
                <>
                    {openSearchForm ? (
                        <Container maxWidth="xl">
                            <SearchFormContent setRequestFlag={setRequestFlag} setUid={setUid} flightRoute={false} openSearchForm={openSearchForm} />
                        </Container>
                    ) : (
                        <DetailsHeader type="bus" data={busInformation} />
                    )}
                </>
            ) : (
                <BaseDialog title={t("edit")} open={openSearchForm} handleClose={handleClose} top="0" icon="close">
                    <DialogContent dividers={true}>
                        <SearchFormContent setRequestFlag={setRequestFlag} setUid={setUid} openSearchForm={openSearchForm} />
                    </DialogContent>
                </BaseDialog>
            )}
        </>
    );
}

export default BusSearchForm;
